import { useCallback } from 'react';

const CAROUSEL_ITEMS = [
  {
    tag: '经典重温',
    title: '港片黄金时代 — 周星驰·成龙·周润发经典合集',
    description: '重温港片辉煌年代，从喜剧之王到动作巅峰，每一帧都是8090后的青春记忆。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20atmosphere%20with%20neon%20signs%20and%20vintage%20film%20posters%2C%20warm%20retro%20lighting%2C%20cinematic%20composition%2C%20golden%20age%20movie%20aesthetic%2C%20rich%20contrast%20and%20texture&width=600&height=400&seq=carousel-hk-cinema&orientation=landscape',
    stat: '收录 200+ 部',
  },
  {
    tag: '4K修复',
    title: '老片焕新 — 4K修复画质专区',
    description: '经典影片经过专业修复，画质大幅提升，老电影也有全新观影体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20being%20restored%20with%20modern%20technology%2C%20split%20screen%20showing%20old%20grainy%20footage%20versus%20crystal%20clear%204K%20quality%2C%20professional%20color%20grading%20suite%2C%20cinematic%20warm%20lighting&width=600&height=400&seq=carousel-4k-restore&orientation=landscape',
    stat: '已修复 150+ 部',
  },
  {
    tag: '热血动漫',
    title: '日漫殿堂 — 海贼王·火影忍者·进击的巨人',
    description: '热血与感动并存，从经典长篇到年度新番，完整收录不间断更新。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20collage%20with%20dynamic%20action%20poses%2C%20vibrant%20warm%20colors%2C%20epic%20adventure%20atmosphere%2C%20cel%20shaded%20illustration%20style%2C%20dramatic%20lighting%20rays%2C%20cinematic%20composition&width=600&height=400&seq=carousel-anime&orientation=landscape',
    stat: '更新至 800+ 集',
  },
  {
    tag: '国产佳剧',
    title: '年度口碑 — 国产电视剧精选合集',
    description: '古装权谋、都市情感、悬疑推理，精选年度高分国产好剧一网打尽。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20elegant%20costume%20design%20with%20rich%20textiles%20and%20golden%20embroidery%2C%20traditional%20Chinese%20architecture%20background%2C%20soft%20warm%20lantern%20lighting%2C%20cinematic%20depth%20of%20field%2C%20artistic%20composition&width=600&height=400&seq=carousel-cdrama&orientation=landscape',
    stat: '精选 60+ 部',
  },
  {
    tag: '好莱坞',
    title: '视觉盛宴 — 好莱坞动作科幻大片专区',
    description: '从漫威宇宙到星际探索，高画质呈现每一场震撼视效与激燃对决。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20with%20dramatic%20space%20nebula%20background%2C%20futuristic%20elements%2C%20golden%20and%20coral%20accent%20lighting%2C%20blockbuster%20movie%20aesthetic%2C%20widescreen%20composition%2C%20high%20contrast&width=600&height=400&seq=carousel-hollywood&orientation=landscape',
    stat: '超 300+ 部大片',
  },
];

export default function CarouselSection() {
  const handleScrollTo = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, []);

  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">焦点专题</h2>
            <p className="mt-2 text-sm text-foreground-500">精选热门专题，一站直达你感兴趣的内容</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
            {CAROUSEL_ITEMS.map((item, i) => (
              <a
                key={i}
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all duration-300"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {item.description}
                  </p>
                  <div className="mt-3 flex items-center gap-1.5 text-primary-600">
                    <i className="ri-film-line text-xs"></i>
                    <span className="text-xs font-medium">{item.stat}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}